<template>
  <div class="app-authentication">
    <div
      v-if="providerLanguageSettings.value"
      class="app-authentication__language-control"
    >
      <VpLanguageSwitcher
        :languages="providerLanguageSettings.languages"
        :value="currentLanguage"
        :provider-color="styles.primaryColor"
        @input="setLanguage"
      />
    </div>
    <VpAuthentication
      :styles="styles"
      :logo="logo"
      :name="name"
      :language="currentLanguage"
      @is-authenticated="onAuthenticated"
    >
    </VpAuthentication>
  </div>
</template>

<script>
export default {
  name: 'AppAuthentication',
  inject: ['$busy', '$byodConfig'],
  emits: ['auth'],
  props: ['providerLanguageSettings'],
  data() {
    return {
      logo: this.$byodConfig.logoLight,
      name: this.$byodConfig.name,
      styles: {
        tabInactiveColor: '#4f4f4f',
        tabBackgroundColor: '#EFF1F2',
        primaryColor: this.$byodConfig.color,
      },
      currentLanguage: this.$i18n.locale,
    };
  },
  computed: {
  },
  methods: {
    setLanguage(langKey) {
      this.currentLanguage = langKey;
      this.$i18n.locale = langKey;
      localStorage.setItem('selectedLanguage', langKey);
      this.$store.commit('updateSelectedLanguage', langKey);
      this.$store.dispatch('dashboard/setLocale', langKey).then(() => {
        if ('lang' in this.$route.query) {
          const { lang, ...rest } = this.$route.query;
          this.$router.replace({ query: { ...rest } });
        }
      });
    },
    onAuthenticated(isAuthenticated) {
      this.$emit('auth', isAuthenticated);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixins.scss';

.app-authentication {
  &__language-control {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;

    .language-button {
      margin-top: 31px;
      margin-right: 53px;
    }

    .language-select {
      margin-top: 18px;
      margin-right: 53px;
      height: 35px;
      width: 131px;
    }
  }
}

@media screen and (max-width: 576px) {
  .language-switcher.language-select,
  .language-switcher.language-button {
    margin: 48px 24px 0 0;
  }

  ::v-deep {
    .vcl-logon .vcl-logon__container {
      position: absolute;
      top: 115px;
    }
    .vcl-logon img {
      position: absolute;
      height: 64px;
      top: 0;
      left: 0;
      margin: 25px 0 0 25px;
    }
  }
}
</style>
